import React from 'react'

import { useMixes } from '../../../firebase/hooks/useMixes'

import { CustomMix } from './CustomMix/CustomMix'
import { NewMix } from './NewMix/NewMix'

const CustomMixes = () => {
  const mixes = useMixes()

  return (
    <>
      {mixes.map((m, idx) => (
        // eslint-disable-next-line react/no-array-index-key
        <CustomMix key={idx} mix={m} />
      ))}
      <NewMix />
    </>
  )
}

export { CustomMixes }
